module.exports = __webpack_public_path__ + "static/media/restroom.f4dbd2e4.png";